export default __webpack_public_path__ + "static/game_development_background-d74a2370a88944ccf9e4a84e48b91fc0.png";